const customCSSPropertiesMap = {
    "maxContentWidth": "--awsui-max-content-width-kcc2gu",
    "minContentWidth": "--awsui-min-content-width-kcc2gu",
    "breadcrumbsGap": "--awsui-breadcrumbs-gap-kcc2gu",
    "contentGapLeft": "--awsui-content-gap-left-kcc2gu",
    "contentGapRight": "--awsui-content-gap-right-kcc2gu",
    "contentHeight": "--awsui-content-height-kcc2gu",
    "contentLayoutDefaultHorizontalPadding": "--awsui-content-layout-default-horizontal-padding-kcc2gu",
    "contentLayoutMaxContentWidth": "--awsui-content-layout-max-content-width-kcc2gu",
    "contentLayoutMainGap": "--awsui-content-layout-main-gap-kcc2gu",
    "defaultMaxContentWidth": "--awsui-default-max-content-width-kcc2gu",
    "defaultMinContentWidth": "--awsui-default-min-content-width-kcc2gu",
    "drawerSize": "--awsui-drawer-size-kcc2gu",
    "footerHeight": "--awsui-footer-height-kcc2gu",
    "headerGap": "--awsui-header-gap-kcc2gu",
    "headerHeight": "--awsui-header-height-kcc2gu",
    "layoutWidth": "--awsui-layout-width-kcc2gu",
    "mainGap": "--awsui-main-gap-kcc2gu",
    "mainOffsetLeft": "--awsui-main-offset-left-kcc2gu",
    "mainTemplateRows": "--awsui-main-template-rows-kcc2gu",
    "mobileBarHeight": "--awsui-mobile-bar-height-kcc2gu",
    "notificationsHeight": "--awsui-notifications-height-kcc2gu",
    "offsetTop": "--awsui-offset-top-kcc2gu",
    "overlapHeight": "--awsui-overlap-height-kcc2gu",
    "navigationWidth": "--awsui-navigation-width-kcc2gu",
    "splitPanelReportedHeaderSize": "--awsui-split-panel-reported-header-size-kcc2gu",
    "splitPanelReportedSize": "--awsui-split-panel-reported-size-kcc2gu",
    "splitPanelHeight": "--awsui-split-panel-height-kcc2gu",
    "splitPanelMinWidth": "--awsui-split-panel-min-width-kcc2gu",
    "splitPanelMaxWidth": "--awsui-split-panel-max-width-kcc2gu",
    "toolsMaxWidth": "--awsui-tools-max-width-kcc2gu",
    "toolsWidth": "--awsui-tools-width-kcc2gu",
    "toolsAnimationStartingOpacity": "--awsui-tools-animation-starting-opacity-kcc2gu",
    "contentScrollMargin": "--awsui-content-scroll-margin-kcc2gu",
    "flashbarStackDepth": "--awsui-flashbar-stack-depth-kcc2gu",
    "flashbarStackIndex": "--awsui-flashbar-stack-index-kcc2gu",
    "flashbarStickyBottomMargin": "--awsui-flashbar-sticky-bottom-margin-kcc2gu",
    "stackedNotificationsBottomMargin": "--awsui-stacked-notifications-bottom-margin-kcc2gu",
    "stackedNotificationsDefaultBottomMargin": "--awsui-stacked-notifications-default-bottom-margin-kcc2gu",
    "dropdownDefaultMaxWidth": "--awsui-dropdown-default-max-width-kcc2gu",
    "spinnerRotatorFrom": "--awsui-spinner-rotator-from-kcc2gu",
    "spinnerRotatorTo": "--awsui-spinner-rotator-to-kcc2gu",
    "spinnerLineLeftFrom": "--awsui-spinner-line-left-from-kcc2gu",
    "spinnerLineLeftTo": "--awsui-spinner-line-left-to-kcc2gu",
    "spinnerLineRightFrom": "--awsui-spinner-line-right-from-kcc2gu",
    "spinnerLineRightTo": "--awsui-spinner-line-right-to-kcc2gu",
    "sliderLabelCount": "--awsui-slider-label-count-kcc2gu",
    "sliderTickCount": "--awsui-slider-tick-count-kcc2gu",
    "sliderReferenceColumn": "--awsui-slider-reference-column-kcc2gu",
    "sliderNextReferenceColumn": "--awsui-slider-next-reference-column-kcc2gu",
    "sliderMaxStart": "--awsui-slider-max-start-kcc2gu",
    "sliderMinEnd": "--awsui-slider-min-end-kcc2gu",
    "sliderRangeInlineSize": "--awsui-slider-range-inline-size-kcc2gu",
    "sliderTooltipPosition": "--awsui-slider-tooltip-position-kcc2gu",
    "togglesLeftWidth": "--awsui-toggles-left-width-kcc2gu",
    "togglesRightWidth": "--awsui-toggles-right-width-kcc2gu",
    "promptInputMaxRows": "--awsui-prompt-input-max-rows-kcc2gu",
    "promptInputScrollHeight": "--awsui-prompt-input-scroll-height-kcc2gu",
    "dragHandleAnimationInlineOffset": "--awsui-drag-handle-animation-inline-offset-kcc2gu",
    "dragHandleAnimationBlockOffset": "--awsui-drag-handle-animation-block-offset-kcc2gu",
    "styleBackgroundActive": "--awsui-style-background-active-kcc2gu",
    "styleBackgroundDefault": "--awsui-style-background-default-kcc2gu",
    "styleBackgroundDisabled": "--awsui-style-background-disabled-kcc2gu",
    "styleBackgroundHover": "--awsui-style-background-hover-kcc2gu",
    "styleBorderColorActive": "--awsui-style-border-color-active-kcc2gu",
    "styleBorderColorDefault": "--awsui-style-border-color-default-kcc2gu",
    "styleBorderColorDisabled": "--awsui-style-border-color-disabled-kcc2gu",
    "styleBorderColorHover": "--awsui-style-border-color-hover-kcc2gu",
    "styleColorActive": "--awsui-style-color-active-kcc2gu",
    "styleColorDefault": "--awsui-style-color-default-kcc2gu",
    "styleColorDisabled": "--awsui-style-color-disabled-kcc2gu",
    "styleColorHover": "--awsui-style-color-hover-kcc2gu",
    "styleFocusRingBorderColor": "--awsui-style-focus-ring-border-color-kcc2gu",
    "styleFocusRingBorderRadius": "--awsui-style-focus-ring-border-radius-kcc2gu",
    "styleFocusRingBorderWidth": "--awsui-style-focus-ring-border-width-kcc2gu",
    "styleFocusRingBoxShadow": "--awsui-style-focus-ring-box-shadow-kcc2gu",
};
export default customCSSPropertiesMap;
//# sourceMappingURL=index.js.map